import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import Heading from 'components/Luxkit/Typography/Heading'
import HowItWorksItems from 'components/Common/HowItWorks/HowItWorksItems'

const HowItWorksSheet = styled(Pane)`
  padding: ${rem(40)} ${rem(20)};
`

const SizedHowItWorks = styled(HowItWorksItems)`
  min-width: ${rem(320)};
`

function HowItWorksBanner() {
  return <HowItWorksSheet type="clean">
    <Heading variant="heading3" align="center">
      Why you should book with us
    </Heading>
    <SizedHowItWorks items={config.offerList.howItWorks.hotel} />
  </HowItWorksSheet>
}

export default React.memo(HowItWorksBanner)
